import styled from 'styled-components';
import { onLightTheme } from 'students/views/shared/styled';

export const SGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: center;
  margin-block-start: 12px;
  font-family: var(--lingu-text-font-family);

  @media (max-width: 500px) {
    display: block;
  }
`;

export const SCell = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 136px;
  width: 147px;
  background: rgba(0, 9, 40, 0.3);
  border-radius: 6px;
  margin-block-start: 10px;
  cursor: pointer;

  ${onLightTheme`
    background: rgb(var(--ln-surface-raised));
    box-shadow: inset 0 0 0 1px var(--ln-tile-edge);

    &.isPicked {
      background: rgb(var(--ln-overlay) / 0.1);
    }
  `}

  &:focus-visible {
    outline: 3px solid var(--color-blue-btn-focus-outline-color);
    outline-offset: 3px;
  }

  @media (max-width: 500px) {
    width: 100%;
    height: 60px;
    margin-block-start: 4px;
    flex-direction: row;
    align-items: center;
  }

  &.isPicked {
    background: rgb(var(--ln-overlay) / 0.1);

    & > div {
      opacity: 1;
    }
  }
`;

export const SImg = styled.img`
  margin-block-start: 25px;
  width: 42px;
  height: 42px;
  display: block;
  border: 0;

  &.isPicked {
    opacity: 0.5;
  }

  ${onLightTheme`
    &:not(.isPicked) {
      filter: brightness(0);
      opacity: 0.7;
    }
  `}

  @media (max-width: 500px) {
    margin-block: 0;
    margin-inline: 18px 0;
  }
`;

export const SSubtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgb(var(--ln-content));
  opacity: 0.8;
`;

export const STitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  color: rgb(var(--ln-content));
  position: relative;
  top: 4px;

  @media (max-width: 500px) {
    top: 0;
    margin-inline: 10px;
  }
`;
